import API from "../http-common";

import { debugLog } from "../utils/debugUtils";

const getAll = () => {
	return API.get("/users");
};

const get = (id) => {
	return API.get(`/users/${id}`);
};

const create = (data) => {
	return API.post("/users", data);
};

const update = (id, data) => {
	return API.put(`/users/${id}`, data);
};

const findByEmail = (email) => {
	return API.get(`/users?email=${email}`);
};
const findByKeyword = (keyword) => {
	return API.get(`/users?kw=${keyword}`);
};
const findByUuid = (uuid) => {
	return API.get(`/users/uuid/${uuid}`);
};

const updateStatus = (id, status_id, updatedBy) => {
	// Could be PATCH or PUT
	// return http.patch(`/baselines/${id}/status`, { status });
	// or PUT depending on your convention
	return API.put(`/users/${id}/status`, { status_id, updatedBy });
};

const UserService = {
	getAll,
	get,
	create,
	update,
	findByEmail,
	findByKeyword,
	findByUuid,
	updateStatus
};

export default UserService;
